import { nanoid } from 'nanoid';
import { useEffect, useState } from 'react';

import { Metadata } from 'src/app/metadata';
import { StudioEditor } from '../studio-editor';
import { EditorMode } from '../types';

function NewStudio() {
  const [studioId, setStudioId] = useState('');

  useEffect(() => {
    const uuid = nanoid();
    setStudioId(uuid);
  }, []);

  return (
    <>
      <Metadata title="Create A Studio - 1TM" />
      <StudioEditor
        heading="Create A Studio"
        studioId={studioId}
        editorMode={EditorMode.CREATE}
      />
    </>
  );
}

export default NewStudio;
